type EditionLike = { id: string };

export function resolveArrivalEdition({
  requestedEditionConfigId,
  editions,
  fallback = editions[0]?.id ?? null,
}: {
  requestedEditionConfigId: string | null | undefined;
  editions: EditionLike[];
  fallback?: string | null;
}): string | null {
  const requestedEditionBelongsToThisPublication = editions.some(
    edition => edition.id === requestedEditionConfigId,
  );

  if (requestedEditionConfigId && requestedEditionBelongsToThisPublication) {
    return requestedEditionConfigId;
  }

  return fallback;
}
